import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "vip-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "vip-wrap"
};
const _hoisted_4 = {
  class: "vip-star-wrap"
};
const _hoisted_5 = {
  class: "vip-value"
};
const _hoisted_6 = {
  class: "vip-label"
};
const _hoisted_7 = {
  class: "vip-level-wrap"
};
const _hoisted_8 = {
  class: "stage-wrap"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "stage-dot"
}, null, -1);
const _hoisted_10 = {
  class: "vip-text"
};
const _hoisted_11 = {
  class: "vip-benefit-title"
};
const _hoisted_12 = {
  class: "vip-benefit-item"
};
const _hoisted_13 = {
  class: "vip-benefit-label"
};
const _hoisted_14 = {
  class: "vip-benefit-value"
};
const _hoisted_15 = {
  class: "vip-benefit-item"
};
const _hoisted_16 = {
  class: "vip-benefit-label"
};
const _hoisted_17 = {
  class: "vip-benefit-value"
};
const _hoisted_18 = {
  class: "vip-benefit-item"
};
const _hoisted_19 = {
  class: "vip-benefit-label"
};
const _hoisted_20 = {
  class: "vip-benefit-value"
};
const _hoisted_21 = {
  class: "vip-benefit-item"
};
const _hoisted_22 = {
  class: "vip-benefit-label"
};
const _hoisted_23 = {
  class: "vip-benefit-value"
};
const _hoisted_24 = {
  class: "top-up-requirement"
};
const _hoisted_25 = {
  key: 0,
  class: "popup-footer flex justify-between"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "footer-top-line"
}, null, -1);
const _hoisted_27 = {
  class: "requirement-wrap"
};
const _hoisted_28 = {
  class: "requirement-label"
};
const _hoisted_29 = {
  class: "requirement-process-wrap"
};
const _hoisted_30 = {
  class: "process-text"
};
const _hoisted_31 = {
  class: "requirement-wrap"
};
const _hoisted_32 = {
  class: "requirement-label"
};
const _hoisted_33 = {
  class: "requirement-process-wrap"
};
const _hoisted_34 = {
  class: "process-text"
};
import { ref, computed, onMounted } from 'vue';
import { useWindowSize } from '@vant/use';
import { usePopupStore } from '@/store';
import PopupHeader from '@/components/Common/PopupHeader';
import Rule from './Rule';
import Record from './Record';
import { queryVipInfo } from '@/api';
export default {
  __name: 'index',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      width,
      height
    } = useWindowSize();
    const popupStore = usePopupStore();
    const vipSwipeRef = ref(null);
    const userVipInfo = ref({});
    const vipInfoList = ref([]);
    const vipIndex = ref(0);
    const showRule = ref(false);
    const showRecord = ref(false);
    const direction = ref('right');
    const nextVipInfo = computed(() => {
      if (userVipInfo.value.vip < vipInfoList.value.length - 1) {
        return vipInfoList.value[userVipInfo.value.vip + 1];
      } else {
        return null;
      }
    });
    const star = computed(() => {
      if (vipIndex.value == 0) {
        return 0;
      } else {
        return vipIndex.value % 5 || 5;
      }
    });
    const topUpAmount = computed(() => {
      var _nextVipInfo$value, _userVipInfo$value;
      const amount = ((_nextVipInfo$value = nextVipInfo.value) === null || _nextVipInfo$value === void 0 ? void 0 : _nextVipInfo$value.upgradeRecharge) - ((_userVipInfo$value = userVipInfo.value) === null || _userVipInfo$value === void 0 ? void 0 : _userVipInfo$value.rechargeTotal);
      if (amount > 0) {
        return amount;
      } else {
        return 0;
      }
    });
    onMounted(() => {
      queryVipInfo().then(res => {
        const data = res.data || {};
        let vipConfigs = data.vipConfigs || [];
        let vipInfo = {};
        vipConfigs.map(item => {
          vipInfo[item.level] = item;
        });
        userVipInfo.value = data.record || {};
        vipInfoList.value = vipConfigs;
        vipIndex.value = userVipInfo.value.vip;
        vipSwipeRef.value.swipeTo(userVipInfo.value.vip);
      });
    });
    const vipStyle = vip => {
      let vipLevel = vipIndex.value;
      if (vip != undefined) {
        vipLevel = vip;
      }
      if (vipLevel == 0) {
        return 1;
      } else {
        return Math.ceil(vipLevel / 5);
      }
    };
    const onChange = index => {
      vipIndex.value = index;
    };
    const processWith = (current, target) => {
      if (current >= target) {
        return 100;
      } else {
        return current / target * 100;
      }
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_popup, {
        class: "full-page",
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => {
          var _nextVipInfo$value2, _nextVipInfo$value3, _nextVipInfo$value4, _nextVipInfo$value5, _nextVipInfo$value6, _nextVipInfo$value7, _nextVipInfo$value8;
          return [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(PopupHeader), {
            ruleIcon: true,
            onClickRule: _cache[0] || (_cache[0] = $event => showRule.value = true),
            recordIcon: true,
            onClickRecord: _cache[1] || (_cache[1] = $event => showRecord.value = true),
            onOnClose: _cache[2] || (_cache[2] = $event => emit('onClose'))
          }), _createElementVNode("div", {
            class: _normalizeClass(`popup-content flex style${vipStyle()}`)
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
            class: _normalizeClass(`vip-star-mask star${star.value}`)
          }, null, 2)]), _createElementVNode("div", _hoisted_5, _toDisplayString(vipIndex.value), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('vip.vip').toUpperCase()), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
            class: _normalizeClass(["chest-wrap", {
              open: vipIndex.value <= userVipInfo.value.vip
            }])
          }, [vipIndex.value <= userVipInfo.value.vip ? (_openBlock(), _createBlock(_component_van_image, {
            key: 0,
            class: "chest-img open",
            fit: "contain",
            src: require(`@/assets/img/vip/style${vipStyle()}/chest-open.png`)
          }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_van_image, {
            key: 1,
            class: "chest-img",
            fit: "contain",
            src: require(`@/assets/img/vip/style${vipStyle()}/chest.png`)
          }, null, 8, ["src"]))], 2), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
            class: "stage-scroll-wrap",
            style: _normalizeStyle(`transform: translate(-${Math.round(vipIndex.value * 40 / 430 * _unref(height))}px);`)
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vipInfoList.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["stage-dot-wrap", {
                'fade-out': direction.value == 'left' && item.level == vipIndex.value + 2 || direction.value == 'right' && item.level == vipIndex.value - 2,
                'fade-in': direction.value == 'left' && item.level == vipIndex.value - 1 || direction.value == 'right' && item.level == vipIndex.value + 1,
                'side': direction.value == 'left' && item.level == vipIndex.value + 1 || direction.value == 'right' && item.level == vipIndex.value - 1,
                'center': item.level == vipIndex.value
              }]),
              key: item.level
            }, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('vip.vip').toUpperCase()) + _toDisplayString(item.level), 1)], 2);
          }), 128))], 4)]), _createVNode(_component_van_swipe, {
            class: "vip-benefit-swipe",
            ref_key: "vipSwipeRef",
            ref: vipSwipeRef,
            "show-indicators": false,
            onChange: onChange
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vipInfoList.value, item => {
              return _openBlock(), _createBlock(_component_van_swipe_item, {
                key: item.level
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: _normalizeClass(`vip-benefit-wrap style${vipStyle(item.level)}`)
                }, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('vip.vipBenefits')) + " " + _toDisplayString(_ctx.$t('vip.vip').toUpperCase()) + _toDisplayString(item.level), 1), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_image, {
                  class: "vip-benefit-icon",
                  fit: "contain",
                  src: require('@/assets/img/vip/benefit/diamond.png')
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('vip.bonusDiamonds')), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.rechargePointRebate) + "%", 1)]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_van_image, {
                  class: "vip-benefit-icon",
                  fit: "contain",
                  src: require('@/assets/img/vip/benefit/loss.png')
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('vip.lossRebate')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(item.lossRebate) + "%", 1)]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_image, {
                  class: "vip-benefit-icon",
                  fit: "contain",
                  src: require('@/assets/img/vip/benefit/slot.png')
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('vip.slotMachineRebates')), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(item.slotRebate) + "%", 1)]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_image, {
                  class: "vip-benefit-icon",
                  fit: "contain",
                  src: require('@/assets/img/vip/benefit/live.png')
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('vip.liveGameRebates')), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(item.liveRebate) + "%", 1)])], 2)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }, 512), _createElementVNode("div", _hoisted_24, _toDisplayString(nextVipInfo.value ? _ctx.$t('vip.topUpRequirements').format({
            amount: topUpAmount.value,
            vip: (_nextVipInfo$value2 = nextVipInfo.value) === null || _nextVipInfo$value2 === void 0 ? void 0 : _nextVipInfo$value2.level
          }) : ''), 1), _withDirectives(_createVNode(_component_van_image, {
            class: "vip-change-btn prev",
            src: require('@/assets/img/vip/right.png'),
            onClick: _cache[3] || (_cache[3] = $event => (vipSwipeRef.value.prev(), direction.value = 'left'))
          }, null, 8, ["src"]), [[_vShow, vipIndex.value > 0], [_directive_audio]]), _withDirectives(_createVNode(_component_van_image, {
            class: "vip-change-btn",
            src: require('@/assets/img/vip/right.png'),
            onClick: _cache[4] || (_cache[4] = $event => (vipSwipeRef.value.next(), direction.value = 'right'))
          }, null, 8, ["src"]), [[_vShow, vipIndex.value < vipInfoList.value.length - 1], [_directive_audio]])])], 2), nextVipInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('vip.rechargeRequirements')), 1), _createElementVNode("div", _hoisted_29, [processWith(userVipInfo.value.rechargeTotal, (_nextVipInfo$value3 = nextVipInfo.value) === null || _nextVipInfo$value3 === void 0 ? void 0 : _nextVipInfo$value3.upgradeRecharge) ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "process-bar",
            style: _normalizeStyle(`width: ${processWith(userVipInfo.value.rechargeTotal, (_nextVipInfo$value4 = nextVipInfo.value) === null || _nextVipInfo$value4 === void 0 ? void 0 : _nextVipInfo$value4.upgradeRecharge)}%`)
          }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_30, _toDisplayString(userVipInfo.value.rechargeTotal) + "/" + _toDisplayString((_nextVipInfo$value5 = nextVipInfo.value) === null || _nextVipInfo$value5 === void 0 ? void 0 : _nextVipInfo$value5.upgradeRecharge), 1)])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('vip.betRequirements')), 1), _createElementVNode("div", _hoisted_33, [processWith(userVipInfo.value.betTotal, (_nextVipInfo$value6 = nextVipInfo.value) === null || _nextVipInfo$value6 === void 0 ? void 0 : _nextVipInfo$value6.upgradeBet) ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "process-bar",
            style: _normalizeStyle(`width: ${processWith(userVipInfo.value.betTotal, (_nextVipInfo$value7 = nextVipInfo.value) === null || _nextVipInfo$value7 === void 0 ? void 0 : _nextVipInfo$value7.upgradeBet)}%`)
          }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_34, _toDisplayString(userVipInfo.value.betTotal) + "/" + _toDisplayString((_nextVipInfo$value8 = nextVipInfo.value) === null || _nextVipInfo$value8 === void 0 ? void 0 : _nextVipInfo$value8.upgradeBet), 1)])]), _withDirectives((_openBlock(), _createBlock(_component_van_button, {
            class: "top-up-btn",
            onClick: _cache[5] || (_cache[5] = $event => (emit('onClose'), _unref(popupStore).set('showDeposit')))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('vip.topUp')), 1)]),
            _: 1
          })), [[_directive_audio]])])) : _createCommentVNode("", true), _createVNode(_component_van_image, {
            class: "right-coin-img",
            src: require('@/assets/img/vip/right-coin.png')
          }, null, 8, ["src"]), _createVNode(_component_van_image, {
            class: "right-person-img",
            src: require('@/assets/img/vip/right-person.png')
          }, null, 8, ["src"])])];
        }),
        _: 1
      })]), showRule.value ? (_openBlock(), _createBlock(_unref(Rule), {
        key: 0,
        onOnClose: _cache[6] || (_cache[6] = $event => showRule.value = false)
      })) : _createCommentVNode("", true), showRecord.value ? (_openBlock(), _createBlock(_unref(Record), {
        key: 1,
        onOnClose: _cache[7] || (_cache[7] = $event => showRecord.value = false)
      })) : _createCommentVNode("", true)], 64);
    };
  }
};